<template lang="pug">
  PrintablePanel
    PageHeader
      | Split By BIO Report Results
    .mt-3.d-flex(v-if="!printable")
      .ml-auto
        router-link.btn.btn-primary(:to="{query: {print: true}}" target="_blank") Print

    Datatable.mt-3(:columns="columns"
      :entries="[0]"
      footer
      :per-page="6"
      :header-style="{fontSize: '12px'}")
      tr.body-3
        td {{ results.bio }}
        td(v-if="results.selectedBio") {{ results.selectedBio.toUpperCase() }}
        td(v-else) None
        td {{ results.id }}
</template>

<script>
import Datatable from '@/components/Datatable'
import PageHeader from '@/components/PageHeader'
import PrintablePanel from '@/components/PrintablePanel'
import { formItem } from '@/lib/formstore'
import axios from '@/lib/axios'
import { globalError } from '@/lib/utils'

export default {
  name: 'SplitByIdResults',
  data: function() {
    return {
      results: Object,
      columns: [
        'Old BIO Key',
        'Updated BIO Key',
        'Existing ID Key',
      ],
    }
  },
  methods: {
  },
  async beforeRouteEnter(to, _from, next) {
    try {
      let results = await axios().get('/api/reports/link', {
        params: { id: to.params.id },
      })
      next(vm => {
        vm.results = results.data.criteria
        if (vm.printable) vm.$nextTick(() => window.print())
      })
    } catch (err) {
      globalError(err)
    }
  },
  mounted() {
    scrollTo(0, 0)
  },
  components: {
    Datatable,
    PageHeader,
    PrintablePanel,
  },
}
</script>

<style lang="scss" scoped>
.border-left {
  border-left: 2px solid #e6e6e6;
}
</style>
